module.exports = __webpack_public_path__ + "img/left_right_layout_5.2b15f7a8.png";